import React, { useState, useEffect } from 'react';
import { FiPrinter, FiInfo, FiArrowLeft } from 'react-icons/fi';
import config from '../../config/config';
import { useLocation, useNavigate } from 'react-router-dom';

export function Fisabilillah() {
  const navigate = useNavigate();
  const [weightData, setWeightData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchWeightReport = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${config.baseUrl}/api/reports/fisabilillah`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      if (!response.ok) throw new Error('Failed to fetch data');
      const data = await response.json();
      setWeightData(data);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchWeightReport(); }, []);

  // --- DATA GROUPING LOGIC ---
  // Pehle Day wise group karenge, phir Day ke andar Sub-category wise
  const groupedData = weightData.reduce((acc, item) => {
    const day = item.slaughtering_day || 'Unknown Day';
    const subcat = item.subcat || 'General';

    if (!acc[day]) acc[day] = {};
    if (!acc[day][subcat]) acc[day][subcat] = [];

    acc[day][subcat].push(item);
    return acc;
  }, {});

  return (
    <div className="min-h-screen bg-slate-50 p-4 md:p-8">
      <style dangerouslySetInnerHTML={{
        __html: `
        @media print {
          @page { size: A4 portrait; margin: 10mm 20mm;}
          .no-print { display: none !important; }
          .page-break { page-break-before: auto !important;}
          #printable-area { width: 100% !important;padding: 15mm 25mm !important;box-sizing: border-box;}
          table { width: 100% !important; table-layout: fixed;border-collapse: collapse !important; margin-bottom: 20px;}
          th, td { border: 1pt solid black !important; border:1px solid #1e293b; padding: 6px; font-size: 9pt; text-align: center; }
          th { background-color: #f8fafc !important; color: black !important; -webkit-print-color-adjust: exact; }
          .day-title { background: #1e293b !important; color: white !important; padding: 8px; margin-top: 20px; -webkit-print-color-adjust: exact; }
        }
      `}} />

      <div id="printable-area" className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="mb-6 flex justify-between items-center">
          <h1 className="text-2xl font-black text-indigo-800 italic">Fisabilillah Distribution List</h1>
          <button onClick={() => window.print()} className=" no-print bg-indigo-800 text-white px-6 py-3 rounded-xl font-bold flex items-center gap-2">
            <FiPrinter /> Print All
          </button>
        </div>

        {loading ? (
          <div className="text-center py-20 animate-pulse">Loading Reports...</div>
        ) : Object.keys(groupedData).length > 0 ? (
          // --- RENDER BY DAY ---
          Object.entries(groupedData).map(([day, subcats], dayIndex) => (
            <div key={day} className="mb-10 ">
              <h2 className="day-title text-xl font-black bg-slate-800 text-white p-3 mb-4 rounded-md uppercase tracking-widest">
                Day: {day}
              </h2>

              {/* --- RENDER BY SUB-CATEGORY --- */}
              {Object.entries(subcats).map(([subcat, items]) => (
                <div key={subcat} className="mb-8">
                  <h3 className="text-md font-bold text-indigo-700 mb-2 border-l-4 border-indigo-700 pl-2">
                    {subcat} <span className="text-slate-400 font-normal">({items.length} Shares)</span>
                  </h3>

                  <div className="bg-white shadow-sm border overflow-hidden">
                    <table className="w-full text-center">
                      <thead>
                        <tr className="bg-slate-100 text-[10px] uppercase font-bold border-b">
                          <th className="py-2 w-16">S.No</th>
                          <th className="py-2">Animal No.</th>
                          <th className="py-2">Share No.</th>
                          <th className="py-2">Type</th>
                        </tr>
                      </thead>
                      <tbody>
                        {items.map((item, idx) => (
                          <tr key={idx} className="border-b last:border-0 hover:bg-slate-50">
                            <td className="py-2 text-slate-400">{idx + 1}</td>
                            <td className="py-2 font-bold text-slate-800">{item.animal_number}</td>
                            <td className="py-2 font-medium text-indigo-600">Share {item.share_number}</td>
                            <td className="py-2 text-slate-600">{item.cat_name}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
            </div>
          ))
        ) : (
          <div className="text-center py-20 bg-white rounded-xl border italic text-slate-400">
            <FiInfo className="mx-auto mb-2" size={30} /> No Fisabilillah data found.
          </div>
        )}
      </div>
    </div>
  );
}